import { render, staticRenderFns } from "./managementOT.vue?vue&type=template&id=5fa19927&"
import script from "./managementOT.vue?vue&type=script&lang=js&"
export * from "./managementOT.vue?vue&type=script&lang=js&"
import style0 from "./managementOT.vue?vue&type=style&index=0&id=5fa19927&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports